import { render } from "./BaseFooter.vue?vue&type=template&id=3f338aca&scoped=true"
const script = {}

import "./BaseFooter.vue?vue&type=style&index=0&id=3f338aca&lang=scss&scoped=true"

import exportComponent from "D:\\pro\\edu-hsd\\cxcj\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f338aca"]])

export default __exports__